import { Component, OnInit, inject } from '@angular/core';
import { EnvironmentService } from '../../../services/environment.service';
import { LanguageService } from '../../../services/language.service';
import {Router} from '@angular/router';
import { TranslationService } from '../../../services/translation/translation.service';
import { SideNavService } from '../../layout/side-menu/side-nav.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NgClass } from '@angular/common';
import { ClickOutsideDirective } from '../../directives/click-outside.directive';

@UntilDestroy()
@Component({
    selector: 'app-locales-selector',
    templateUrl: './locales-selector.component.html',
    styleUrls: ['./locales-selector.component.scss'],
    imports: [ClickOutsideDirective, NgClass]
})
export class LocalesSelectorComponent implements OnInit {
  env = inject(EnvironmentService);
  language = inject(LanguageService);
  private _sidebar = inject(SideNavService);
  private _router = inject(Router);
  private _translationService = inject(TranslationService);


  /**
   * Property for toggle dropdown
   */
  open: boolean;

  ngOnInit(): void {
  }

  /**
   * Change UI language
   *
   * @param lang
   */
  changeLanguage(lang: string) {
    // logic for tech page
    if (!this._router.url.includes(this.language.current)) {
      this.language.changeLang(lang);
    }

    const url = this._router.url.replace(`/${ this.language.current }`, `/${ lang }`);
    this._router.navigateByUrl(`/${ url }`, {replaceUrl: true})
      .then(() => {
        this.language.langChangeFromSelector$.next(true);
        this._translationService.getUserTranslates$().pipe(
          untilDestroyed(this),
        ).subscribe(() => {
          this._sidebar.close();
        });
      });
  }
}
